export enum AgreementStatus {
  pending,
  accepted,
  completed,
}

export enum SelectionStatus {
  onHold,
  active,
  closed,
}
